import { DataSource, Label, Layout } from "@mcleod/components";

export abstract class AutogenLayoutShipmentStatusErrorsCustomerService extends Layout {
    labelInCustomer: Label;
    labelTotalCount: Label;
    sourceCustomerShipmentStatusErrors: DataSource;
}
